import React, {useState, useEffect } from "react";
import Api from "../../fetchs/Api";
import HipervinCole from "../DOM/HipervinCole";
import Modals from "../../componentesHTML/componentesSecundarios/Modals";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import Highlighter from "react-highlight-words"
import ApiInsertarBusquedaClic from "../../fetchs/ApiInsertarBusquedaClic";
import ApiInsertarBusqueda from "../../fetchs/ApiInsertarBusqueda";
function BuscadorBie(parametros) {
  const _updateTotalDatos= useStoreGlobal(useShallow((state) => state._updateTotalDatos));
  let apiData = "";
  const [isActive, setIsActive] = useState(true);
  let var_ingles = "es";
  
  if (window.location.href.indexOf("en.") > -1) {
    var_ingles = "en";
  }
  const registradatos = ((TITULO,URL,metodoBusqueda) => {
      TITULO= TITULO.replace(/['°|@_=¿?¡!~:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
      let metodo="";
      if (metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (metodoBusqueda === 3){
        metodo="Frase completa";
      }
      const param = {
        CONTADOR_CLICK: 1,
        ID_COLECCION: "9",
        IP_USER: "",
        Metodo: metodo,
        Palabra_relacionada: "",
        TEXTO_BUSCADO: parametros.textoBusqueda,
        TITULO_URL: TITULO.replace(/['°|@_=¿~?¡!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " "),
        URL: URL
      };
    ApiInsertarBusquedaClic(param);
  });
  const handleClickDescAsc = (event) => {
    let nodoTooltip = document.querySelectorAll('[role="tooltip"]');
        nodoTooltip.forEach(element => {
            element.remove();
        });
    let clase = event.currentTarget.className;
    if(clase === "inegi-nav-desp"){
      event.currentTarget.className = "inegi-nav-despa";
    }
    else{
      event.currentTarget.className = "inegi-nav-desp";
    }
    setIsActive(!isActive);
  };
  const explorador = (e,RWnivel1,indicador, maximo) => {
    handleClickDescAsc(e);
    let clase = e.currentTarget.className;
    if(clase === "inegi-nav-despa"){
      exploradorDatos(RWnivel1).init(var_ingles, indicador, "00", "", "maximo", '9999', '9999', '0000000', true, true, "", "grafica", "", maximo != "1" ? true : false, "0");
    }
  }
  let idioma =
  var_ingles === "es"
    ? "Fecha de última actualización:"
    : "Date for last update:";
function fecha(fecha){
  let fec = fecha.split("T");
  return fec[0];
}
  if (parametros.coleccionTodo != "Todo") {
    let metodo="";
      if (parametros.metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (parametros.metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (parametros.metodoBusqueda === 3){
        metodo="Frase completa";
      }
    HipervinCole(
      "Bie",
      var_ingles
    );
    const param = {
      busqueda: parametros.textoBusqueda,
      busquedaCiencia: "",
      paginaInicio: parametros.pageInicial,
      paginaFin: parametros.pageFin,
      filtrobusqueda: parametros.camposBuscador,
      filtrotema: "null",
      orderby: parametros.camposOrden,
      orderbyAscDesc: parametros.ordenamiento,
      metodoBusqueda: parametros.metodoBusqueda
    };
      apiData = Api("/app/api/buscadorcore/v1/busquedaBIE/", param)
      function RegistraBus(data){
            if(data.length > 0)
              ApiInsertarBusqueda(parametros.textoBusqueda ,"9", data[0].TOTAL, metodo);
            else
              ApiInsertarBusqueda(parametros.textoBusqueda ,"9", 0, metodo);
          }
      useEffect(() => {
        let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
          return new bootstrap.Tooltip(tooltipTriggerEl)
        }) 
        if (!apiData.loading){
          RegistraBus(apiData.data)
        }
        if(apiData.data.length > 0) {
          document.getElementById('resultados').innerHTML= apiData.data[0].TOTAL;
        _updateTotalDatos({totalDatos:apiData.data[0].TOTAL});
        }else{
          _updateTotalDatos({totalDatos:0});
          document.getElementById('resultados').innerHTML= 0;
        }
      },[apiData.data]);
    return (
        <>
          { apiData.loading? <Modals />:
            !apiData.loading && apiData.data.map((datos,i) => (
              <div className="col-xs-12 col-sm-12 todo" key={"coleccionBuscadorBie-" + i} style={{ marginBottom: "26px", textAlign: "justify" }} id={"resultadoGeneral-" + i}>
                
                <div className="col-xs-12 col-sm-12" style={{paddingLeft:"0px", display:"inline-flex"}} id={"snippet_row_titulo-" + i}>
                  <div className="col-xs-11 col-sm-11 col-lg-10" style={{paddingLeft:"0px"}} id={"primero-" + i}>
                      <a target="_blank" href={"/app/indicadores/?tm=0&ind=" + datos.INDICADOR} id={"Titulo_" + i}>
                      <span id={"gadget-" + i} onClick={() =>registradatos(datos.TITULO, "/app/indicadores/?tm=0&ind=" + datos.INDICADOR, parametros.metodoBusqueda)}>
                        {
                          datos.UNIDAD_MEDIDA
                        }
                      </span>
                      </a>
                  </div>
                  <div className="col-xs-1 col-sm-1 col-lg-2" style={{paddingLeft:"0px"}} id={"segundo-" + i} data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={
                            isActive
                              ? var_ingles === "es"
                                ? "Abrir"
                                  : "Open"
                                  : var_ingles === "es"
                                    ? "Cerrar"
                                      : "Close"
                            }>
                    <div
                                data-bs-toggle="collapse"
                                href={"#multiCollapseExample-" + i}
                                aria-expanded="false"
                                aria-controls={"multiCollapseExample-" + i}
                                className={"inegi-nav-desp"}
                                onClick ={(e) => explorador(e, "#RWnivel-" + i, datos.INDICADOR,"1")}
                                style={{ paddingLeft: "5px", width: "58%", float: "right" }}
                              >
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-11 esp" style={{paddingLeft:"0px"}} id={"snippet_row_Programa-" + i}>
                  <div style={{textAlign:"justify"}} id={"row-1-" + i}>
                    <p id="parrafo-0">
                      <span className="indLink" id={"elemento_a-" + i}>
                        <Highlighter
                          highlightClassName="highlight"
                          searchWords={[parametros.textoBusqueda, parametros.textoBusqueda + "s", parametros.textoBusqueda + "es"]}
                          autoEscape={true}
                          textToHighlight= { datos.TITULO}
                        /> 
                      </span>
                    </p>
                  </div>
                </div>
                <div className="col-xs-12" id={"padreCollapse-" + i}>
                  <div className="col-xs-12 col-sm-12 collapse multi-collapse" id={"multiCollapseExample-" + + i}>
                    <div id={"RWnivel-" + i}>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-lg-11 col-sm-12" style={{paddingLeft:"0px", textAlign:"justify"}} id={"row-fuente-Bie-" + i}>
                  <span className="formato_fecha" id={"row-fuente-id-Bie-" + i}>{datos.FUENTE_DESCRIPCION}
                  </span>
                </div>
                <div
                  className="col-xs-12" style={{ marginTop: "5px" }} id={"nivel3-" + i}>
                  <div className="col-xs-12 formato_fecha" id={"nivel3-1-" + i}>
                    <span className="indLink" id={"fecha_actual-" + i}> 
                      {idioma + " " + fecha(datos.FECHA_PUBLICACION)}
                    </span>
                  </div>
                </div>
              </div>
            ))
          }
        </>
      );
  }
  else{
    let datos=parametros.datos;
    let id= parametros.id;
    let metodo= parametros.metodo;
    useEffect(() => { 
      let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
          let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
              return new bootstrap.Tooltip(tooltipTriggerEl)
        }) 
    }, [datos]);
    return (
            <div className="col-xs-12 col-sm-12 todo" key={"coleccionBuscadorBie-" + id} style={{ marginBottom: "26px", textAlign: "justify" }} id={"resultadoGeneral-" + id}>
              
              <div className="col-xs-12 col-sm-12" style={{paddingLeft:"0px", display:"inline-flex"}} id={"snippet_row_titulo-" + id}>
                <div className="col-xs-11 col-sm-11 col-lg-10" style={{paddingLeft:"0px"}} id={"primero-" + id}>
                    <a target="_blank" href={"/app/indicadores/?tm=0&ind=" + datos.INDICADOR} id={"Titulo_" + id}>
                    <span id={"gadget-" + id} onClick={() =>registradatos(datos.TITULO, "/app/indicadores/?tm=0&ind=" + datos.INDICADOR, metodo)}>
                      {
                        datos.UNIDAD_MEDIDA
                      }
                    </span>
                    </a>
                </div>
                <div className="col-xs-1 col-sm-1 col-lg-2" style={{paddingLeft:"0px"}} id={"segundo-" + id} data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={
                            isActive
                              ? var_ingles === "es"
                                ? "Abrir"
                                  : "Open"
                                  : var_ingles === "es"
                                    ? "Cerrar"
                                      : "Close"
                            }>
                  <div
                              data-bs-toggle="collapse"
                              href={"#multiCollapseExample-" + id}
                              aria-expanded="false"
                              aria-controls={"multiCollapseExample-" + id}
                              className={"inegi-nav-desp"}
                              onClick ={(e) => explorador(e, "#RWnivel-" + id, datos.INDICADOR,"1")}
                              style={{ paddingLeft: "5px", width: "58%", float: "right" }}
                              id={"snippet_row_Secundario-Tooltip-" + id}
                            >
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-11 esp" style={{paddingLeft:"0px"}} id={"snippet_row_Programa-" + id}>
                <div style={{textAlign:"justify"}} id={"row-1-" + id}>
                  <p id="parrafo-0">
                    <span className="indLink" id={"elemento_a-" + id}>
                        <Highlighter
                          highlightClassName="highlight"
                          searchWords={[parametros.textoBusqueda, parametros.textoBusqueda + "s", parametros.textoBusqueda + "es"]}
                          autoEscape={true}
                          textToHighlight= { datos.TITULO}
                        /> 
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-xs-12" id={"padreCollapse-" + id}>
                <div className="col-xs-12 col-sm-12 collapse multi-collapse" id={"multiCollapseExample-" + + id}>
                  <div id={"RWnivel-" + id}>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-lg-11 col-sm-12" style={{paddingLeft:"0px", textAlign:"justify"}} id={"row-fuente-Bie-" +id}>
                <span className="formato_fecha" id={"row-fuente-id-Bie-" + id}>{datos.FUENTE_DESCRIPCION}
                </span>
              </div>
              <div
                className="col-xs-12" style={{ marginTop: "5px" }} id={"nivel3-" + id}>
                <div className="col-xs-12 formato_fecha" id={"nivel3-1-" + id}>
                  <span className="indLink" id={"fecha_actual-" + id}> 
                    {idioma + " " + fecha(datos.FECHA_PUBLICACION)}
                  </span>
                </div>
              </div>
            </div>
    );
  }

}
export default BuscadorBie;
